export const environment = {
  production: false,
  // apiUrl: 'https://dev.backend.finqy.ai',
  apiUrl: 'https://devlmsapi.banqmart.com',
  partnerBaseUrl: 'https://qappapi.finqy.ai/api/v1',
  authUrl: 'https://api-auth.finqy.ai/oauth/getAccesstoken',
  imageBaseUrl: 'assets/images/',   // Local folder path for dev/uat
  //imageBaseUrl: '',  // CDN URL for live
};